/**
 * @generated SignedSource<<1f892e5bb555d0cd70f5ace55a0b538c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ForecastSurplusModalChartSection_project$data = {
  readonly projectFirstDateYear: number | null;
  readonly projectFirstDateMonth: number | null;
  readonly projectFirstDateDay: number | null;
  readonly projectLastDateYear: number | null;
  readonly projectLastDateMonth: number | null;
  readonly projectLastDateDay: number | null;
  readonly revenueMarginLow: number | null;
  readonly revenueMarginHigh: number | null;
  readonly aggregatedFinancialNumbers: ReadonlyArray<string | null>;
  readonly " $fragmentType": "ForecastSurplusModalChartSection_project";
};
export type ForecastSurplusModalChartSection_project$key = {
  readonly " $data"?: ForecastSurplusModalChartSection_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"ForecastSurplusModalChartSection_project">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ForecastSurplusModalChartSection_project",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "projectFirstDateYear",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "projectFirstDateMonth",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "projectFirstDateDay",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "projectLastDateYear",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "projectLastDateMonth",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "projectLastDateDay",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "revenueMarginLow",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "revenueMarginHigh",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "addAccumulatedNumbers",
          "value": true
        },
        {
          "kind": "Literal",
          "name": "aggregateLevel",
          "value": "DAY"
        },
        {
          "kind": "Literal",
          "name": "aggregates",
          "value": [
            "actualRevenue",
            "forecastRevenue"
          ]
        },
        {
          "kind": "Literal",
          "name": "convertToProjectCurrency",
          "value": true
        }
      ],
      "kind": "ScalarField",
      "name": "aggregatedFinancialNumbers",
      "storageKey": "aggregatedFinancialNumbers(addAccumulatedNumbers:true,aggregateLevel:\"DAY\",aggregates:[\"actualRevenue\",\"forecastRevenue\"],convertToProjectCurrency:true)"
    }
  ],
  "type": "ProjectType",
  "abstractKey": null
};

(node as any).hash = "de61213dbe10a2887dd6436cd2319e3d";

export default node;
